import React from 'react';
import MissionsTable from '../components/missionsComponents/MissionsTable';

const Missions = () => (
  <div className="missions-page-container">
    <MissionsTable />
  </div>
);

export default Missions;
